<template>
  <div class="content-config-showroom">
    <v-container fluid>
      <v-row>
        <v-col v-for="(item, index) in config_type_showroom" cols="6" :key="index" >
          <div class="block-config rounded-lg px-4 py-4">
            <div class="title mb-2">
              {{title_config[index]}}
            </div>
            <div>
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  v-model="item.title"
                  label="Tên tiêu đề"
                  placeholder="Nhập tên showroom chính hãng"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  v-model="item.slug"
                  label="SLug"
                  placeholder="Nhập slug"
              ></v-text-field>
            </div>
            <div>
              <v-textarea
                  background-color="#EDF2F7"
                  filled
                  v-model="item.meta_desc"
                  label="Mô tả seo"
                  placeholder="Nhập mô tả seo"
              ></v-textarea>
            </div>
            <div>
              <ck-content class="ck-news" :content="item.description" @getData="value => item.description = value" />
            </div>
            <div>
              <div>
                <v-file-input
                    label="Ảnh desktop"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="fileBanner($event,  item)"
                ></v-file-input>
              </div>
              <v-img :src="item.photo_url"></v-img>
            </div>
          </div>

        </v-col>
      </v-row>
      <div class="mt-16">
        <div class="d-flex justify-center">
          <v-btn color="primary" width="180" @click="save_config()">
            Lưu
          </v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import CkContent from "@/components/ck-content"
import {UPLOAD_IMAGE} from "@/store/modules/configs";
import {DETAIL_CONFIG_SHOWROOM, UPDATE_CONFIG_TYPE_SHOWROOM} from "@/store/modules/showroom"
import {mapGetters} from 'vuex'

export default {
  components: { CkContent },
  data() {
    return {
      title_config: [
          "Showroom chính hãng",
          "Showroom ủy quyền",
          "Điểm giao dịch",
          "Showroom thiết kế kiến trúc"
      ]
    }
  },
  mounted() {
    this.$store.dispatch(`${DETAIL_CONFIG_SHOWROOM}`);
  },
  computed:{
    ...mapGetters({
      config_type_showroom: "config_type_showroom",
    })
  },
  methods:{
    save_config() {
      let payload = {
        data : this.config_type_showroom
      }
      this.$store.dispatch(`${UPDATE_CONFIG_TYPE_SHOWROOM}`, payload).then(data => {
        if (data) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$store.dispatch(`${DETAIL_CONFIG_SHOWROOM}`);
        }else {
          alert(data.errors);
        }
      })
    },
    fileBanner(event, item) {
      if (event) {
        // this[type] = URL.createObjectURL(event);
        let formData = new FormData();
        formData.append("upload", event);
        formData.append("type", "banners");
        this.$store
            .dispatch(`${UPLOAD_IMAGE}`, formData)
            .then((data) => {
              if (data && data.data && data.data.data) {
                data.data.data.forEach((element) => {
                  item.photo_url = element.url;
                  item.photo_url_path = element.path;
                });
              }
            });
      }
      this.$forceUpdate()
    },
  }
}
</script>
<style lang="scss">
.content-config-showroom {
  .block-config {
    border: 1px solid black;
  }
}
</style>